<template>
  <div id="themeManagerment" class="h-full">
    <el-row class="h-full" :gutter="10">
      <!-- 左侧树形 -->
      <el-col :span="6" class="h-full" v-show="isShowTreeMode">
        <el-card class="h-full relative" :body-style="{ padding: '20px', height: '100%' }">
          <div class="leftCard text-14px">
            <div class="mb-20px flex justify-between">
              <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px">主题列表</div>
              <el-dropdown>
                <span class="el-dropdown-link">
                  <i
                    class="iconfont icon-line-moreVertical text-14px font-bold !text-[#606266]"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="operateTree(true)">
                    {{ $t('expandAll') }}
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="operateTree(false)">
                    {{ $t('collapseThemAll') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-row class="LeftTop mb-10px" :gutter="20">
              <el-col :span="24" class="flex">
                <el-input
                  size="small"
                  class="mr-10px"
                  v-model="themeKeyword"
                  :placeholder="$t('请输入主题名称')"
                  @keyup.enter.native="queryTreeList"
                  clearable
                ></el-input>
                <el-button type="primary" @click="queryTreeList">{{ $t('search') }}</el-button>
              </el-col>
            </el-row>
            <div class="list text-16px overflow-y-auto pl-10px pr-10px" v-if="this.listType === 2">
              <div v-show="columnList.length" v-for="(it, index) in columnList" :key="index">
                <span class="text-16px">{{ it.name }}</span>
                <div
                  v-for="(item, index) in it.data"
                  :key="index"
                  class="listItem flex pl-10px pr-10px"
                  :class="selectedThemeId === item.id ? 'active' : ''"
                  @click="selectedColumnTheme(item.id)"
                >
                  <span class="text-overflow text-16px pl-5px flex-1">{{ item.name }}</span>
                  <el-dropdown
                    class="flex float-right"
                    @command="($event) => handleCommand($event, item)"
                  >
                    <span class="el-dropdown-link">
                      <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="add" v-if="$hasAccess('create')"
                        >新增</el-dropdown-item
                      >
                      <el-dropdown-item command="edit" v-if="$hasAccess('update')"
                        >编辑</el-dropdown-item
                      >
                      <el-dropdown-item command="delete" v-if="$hasAccess('delete')"
                        >删除</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="tc text-color-grey-999 text-16px noData" v-show="!columnList.length">
                暂无数据
              </div>
            </div>
            <!-- 主题列表树 -->
            <el-tree
              v-if="treeStandBy && this.listType === 1"
              ref="topicTree"
              :data="treeData"
              @node-click="handleNodeClick"
              highlight-current
              lazy
              :load="loadNode"
              :props="defaultProps"
              :expand-on-click-node="false"
              :default-expand-all="isExpandAll"
              node-key="id"
            >
              <div class="flex-1" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <el-dropdown
                  class="float-right rightSpan"
                  @command="($event) => handleCommandTree($event, data, node)"
                >
                  <span class="el-dropdown-link">
                    <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="add" v-if="$hasAccess('create')"
                      >新增</el-dropdown-item
                    >
                    <el-dropdown-item command="edit" v-if="$hasAccess('update') && !data.isStandard"
                      >编辑</el-dropdown-item
                    >
                    <el-dropdown-item
                      command="delete"
                      v-if="$hasAccess('delete') && !data.isStandard"
                      >删除</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-tree>
          </div>
          <div v-if="isShowTreeMode" class="absolute right-0 top-1/2" @click="changeTreeMode">
            <i class="iconfont icon-bg-circleLeft text-24px"></i>
          </div>
        </el-card>
      </el-col>
      <!-- 右侧表格 -->
      <el-col :span="isShowTreeMode ? 18 : 24" class="h-full">
        <el-card class="h-full relative" :body-style="{ padding: '20px', height: '100%' }">
          <div class="absolute left-0 top-1/2" v-if="!isShowTreeMode" @click="changeTreeMode">
            <i class="iconfont icon-bg-circleRight text-24px"></i>
          </div>
          <el-row class="rightTop">
            <el-input
              size="small"
              class="w-250px mr-10px"
              v-model="entityKeyword"
              placeholder="请输入实体名称或实体代码"
              clearable
            ></el-input>
            <el-button type="primary" @click="getRelationClassList">{{ $t('search') }}</el-button>
            <el-button :disabled="!$hasAccess('create')" type="primary" @click="addEntity">{{
              $t('create')
            }}</el-button>
            <el-button :disabled="!$hasAccess('delete')" type="danger" @click="delMore">{{
              $t('delete')
            }}</el-button>
          </el-row>
          <div class="tableBox mt-20px">
            <el-table
              :data="tableData"
              v-loading="tableDataLoading"
              :row-key="(record) => record.id"
              border
              ref="table"
              class="w-full"
              :highlight-current-row="true"
              @selection-change="handleSelectionChange"
              stripe
              height="calc(100% - 50px)"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55"
              ></el-table-column>
              <el-table-column :label="$t('序号')" prop="seqNo" width="55"></el-table-column>
              <el-table-column :label="$t('实体代码')" prop="classCode"> </el-table-column>
              <el-table-column :label="$t('实体名称')" prop="className"> </el-table-column>
              <el-table-column :label="$t('操作')" width="150">
                <template slot-scope="scope">
                  <el-button
                    @click.native="viewEntity(scope.row.classId)"
                    size="mini"
                    :disabled="!$hasAccess('read')"
                    >{{ $t('view') }}</el-button
                  >
                  <el-button
                    :disabled="!$hasAccess('delete')"
                    @click.native="delEntity(scope.row.id)"
                    size="mini"
                    >{{ $t('delete') }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-20px float-right pagination">
              <el-pagination
                background
                @current-change="getRelationClassList"
                @size-change="getRelationClassList"
                :current-page.sync="pageNo"
                :page-size.sync="pageSize"
                :page-sizes="$pageSizeAll"
                layout="total, sizes, prev, pager, next, jumper"
                :total="recordCount"
              ></el-pagination>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增编辑主题弹窗 -->
    <el-dialog
      :title="dialogThemeTitle"
      :visible.sync="themeDialog"
      :close-on-click-modal="false"
      class="small-dialog"
      v-dialogDrag
      :before-close="closeThemeDialog"
    >
      <el-form label-width="150px" ref="themeForm" :rules="themeFormRules" :model="themeForm">
        <el-row :gutter="20" class="pl-10px pr-20px">
          <el-col :span="24">
            <el-form-item :label="$t('序号')" prop="seqNo">
              <el-input-number
                v-model="themeForm.seqNo"
                :controls="false"
                size="small"
                class="w-440px"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('代码')" prop="code" class="w-full">
              <el-input size="small" clearable v-model.trim="themeForm.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('名称')" prop="name" class="w-full">
              <el-input size="small" clearable v-model.trim="themeForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('备注')" prop="remark" class="w-full">
              <el-input
                size="small"
                clearable
                type="textarea"
                v-model.trim="themeForm.remark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" :loading="btnLoading" @click="handleThemeSave">{{
          $t('save')
        }}</el-button>
        <el-button @click="closeThemeDialog">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 关联实体弹窗 -->
    <el-dialog
      title="关联实体"
      class="small-dialog"
      :visible.sync="associateDialog"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <el-row :gutter="20">
        <el-col :span="12" class="flex">
          <el-input
            size="small"
            class="mr-10px"
            v-model="entityKeywordDialog"
            placeholder="请输入实体名称或实体编码"
            clearable
          ></el-input>
          <el-button type="primary" @click="getClassList">{{ $t('search') }}</el-button>
        </el-col>
      </el-row>
      <div class="associateTable mt-10px">
        <el-table
          :data="tableClassData"
          v-loading="tableDataLoading"
          :row-key="(record) => record.classId"
          border
          ref="classTable"
          class="w-full"
          :highlight-current-row="true"
          @selection-change="handleSelectionChangeClass"
          height="calc(100% - 20px)"
          stripe
        >
          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column :label="$t('序号')" prop="seqNo" width="55"> </el-table-column>
          <el-table-column :label="$t('实体代码')" prop="classCode"> </el-table-column>
          <el-table-column :label="$t('实体名称')" prop="className"> </el-table-column>
        </el-table>
        <div class="mt-10px float-right pagination">
          <el-pagination
            background
            @current-change="getClassList()"
            @size-change="getClassList('toggle')"
            :current-page.sync="pageNoClass"
            :page-size.sync="pageSizeClass"
            :page-sizes="[15, 30, 50]"
            :pager-count="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordCountClass"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" :loading="btnLoading" @click="saveAssociate">{{
          $t('save')
        }}</el-button>
        <el-button @click="associateDialog = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 实体详情弹窗 -->
    <el-dialog
      title="实体详情"
      :visible.sync="entityDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form label-width="150px" ref="entityForm" :model="entityForm">
        <el-row :gutter="20" class="pl-10px pr-20px">
          <el-col :span="24">
            <el-form-item :label="$t('实体代码')" prop="code" class="w-full">
              <el-input readonly size="small" clearable v-model.trim="entityForm.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('实体名称')" prop="name" class="w-full">
              <el-input size="small" clearable v-model.trim="entityForm.name" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('序号')" prop="seqNo">
              <el-input
                readonly
                size="small"
                class="w-full"
                clearable
                v-model.trim="entityForm.seqNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('表名')" prop="tableName">
              <el-input
                readonly
                size="small"
                class="w-full"
                clearable
                v-model.trim="entityForm.tableName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('描述')" prop="description" class="w-full">
              <el-input
                readonly
                size="small"
                type="textarea"
                v-model.trim="entityForm.description"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('备注')" prop="remark" class="w-full">
              <el-input
                size="small"
                v-model.trim="entityForm.remark"
                type="textarea"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button class="iconfont icon-close" @click="entityDialog = false" size="small">{{
          $t('cancel')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import StdSubjectDomainService from '@/services/bsApi/StdSubjectDomainService'
import stdClassListService from '@/services/stdClassListService'

export default {
  name: 'themeManagerment',
  components: {},
  data() {
    return {
      standardList: [],
      themeKeyword: '',
      treeData: [],
      columnList: [],
      listType: 1, // 1代表树， 2代表列表
      selectedTheme: {},
      selectedNode: {},
      selectedThemeId: '',
      treeLoading: false,
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      tableData: [],
      selectedEntityList: [],
      tableDataLoading: false,
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
      btnLoading: false,
      dialogThemeTitle: '新增主题',
      themeDialog: false,
      themeForm: {
        seqNo: undefined,
        name: '',
        code: '',
        remark: '',
      },
      themeFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: this.$t('pleaseEnterCode'), trigger: 'blur' }],
      },
      entityKeyword: '',
      associateDialog: false,
      entityDialog: false,
      entityKeywordDialog: '',
      entityForm: {},
      typeClassList: [],
      parentTypeList: [],
      classRelationLabelList: [],
      pageNoClass: 1,
      pageSizeClass: 15,
      recordCountClass: null,
      tableClassData: [],
      selectedClassList: [],
      allEntityList: [],
      isShowTreeMode: true,
      isExpandAll: false, // 是否展开所有目录树
      treeStandBy: true, // 是否显目录树 用于刷新树
      defaultExpandedKeys: [], // 默认展开目录树
    }
  },
  computed: {},
  watch: {
    themeKeyword(val) {
      if (!val) {
        this.listType = 1
        this.getStandardList()
      }
    },
    associateDialog(val) {
      if (!val) {
        // 关闭弹窗后，清除搜索条件
        this.entityKeywordDialog = ''
      }
    },
  },
  async created() {
    this.getStandardList()
  },
  methods: {
    // 收缩实体树
    changeTreeMode() {
      this.isShowTreeMode = !this.isShowTreeMode
    },
    closeThemeDialog() {
      this.themeDialog = false
      this.$refs.themeForm.resetFields()
    },
    handleCommand(command, item) {
      if (command === 'add') {
        this.addTheme(item)
      } else if (command === 'edit') {
        this.editTheme(item)
      } else if (command === 'delete') {
        this.delTheme(item)
      }
    },
    handleCommandTree(command, data, node) {
      if (command === 'add') {
        this.addTheme(data, node)
      } else if (command === 'edit') {
        this.editTheme(data, node)
      } else if (command === 'delete') {
        this.delTheme(data, node)
      }
    },
    // 关键字查询主题树列表
    async queryTreeList() {
      if (!this.themeKeyword) {
        this.$message({
          message: '请输入关键字',
          type: 'warning',
        })
        return
      }
      this.listType = 2
      const parameter = {
        keyword: this.themeKeyword,
      }
      const res = await StdSubjectDomainService.queryTreeList(parameter)
      if (res && res.data && res.code === 0) {
        const arr = []
        // 处理列表数据结构
        res.data.forEach((item) => {
          const obj = {
            name: '',
            id: '',
            isStandard: true,
            data: [],
          }
          this.standardList.forEach((it) => {
            if (item.standardId === it.id) {
              obj.name = it.name
              obj.id = it.id
              obj.seqNo = it.seqNo
              arr.push(obj)
            }
          })
        })
        const newArr = _.uniqBy(arr, 'name')
        res.data.forEach((item) => {
          newArr.forEach((it) => {
            if (item.standardId === it.id) {
              it.data.push(item)
            }
          })
        })
        this.columnList = _.sortBy(newArr, (item) => {
          return item.seqNo
        })
      }
    },
    // 选中主题，获取关联列表
    selectedColumnTheme(id) {
      this.selectedThemeId = id
      this.getRelationClassList()
    },
    // 获取标准列表
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
        this.standardList.forEach((item) => {
          this.$set(item, 'children', [])
          this.$set(item, 'isStandard', true)
          this.$set(item, 'parentId', '')
        })
        this.treeData = _.sortBy(this.standardList, (item) => {
          return item.seqNo
        })
      }
    },
    // 获取所有实体列表
    async getAllEntity() {
      const parameter = {
        standardid: this.selectedTheme.standardId,
        id: this.selectedThemeId,
        keyword: this.entityKeywordDialog,
        pageno: 1,
        pagesize: 999,
        data_type: 0,
      }
      const res = await StdSubjectDomainService.getSelectRelationClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.allEntityList = res.data
      }
    },
    // 获取弹窗实体列表
    async getClassList(type) {
      const parameter = {
        standardid: this.selectedTheme.standardId,
        id: this.selectedThemeId,
        keyword: this.entityKeywordDialog,
        pageno: this.pageNoClass,
        pagesize: this.pageSizeClass,
        data_type: 0,
      }
      if (this.entityKeywordDialog) {
        parameter.pageno = 1
      }
      const res = await StdSubjectDomainService.getSelectRelationClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.tableClassData = res.data
        if (type !== 'toggle') {
          const arr = this.tableClassData.filter((item) => {
            return item.isCheck
          })
          arr.forEach((item) => {
            this.$nextTick(() => {
              this.$refs.classTable.toggleRowSelection(item, true)
            })
          })
        }
        if (res.page) {
          this.recordCountClass = res.page.recordCount
        }
      }
    },
    // 选中实体列表
    handleSelectionChangeClass(val) {
      this.selectedClassList = val
    },
    // 主题树懒加载
    async loadNode(node, resolve) {
      if (node.level > 0) {
        const parameter = {}
        if (node.data.isStandard) {
          parameter.standardId = node.data.id
        } else {
          parameter.standardId = node.data.standardId
          parameter.parentId = node.data.id
        }
        const res = await StdSubjectDomainService.getTreeList(parameter)
        if (res && res.code === 0 && res.data) {
          return resolve(res.data)
        }
      }
      return resolve([])
    },
    // 展开/合并目录树
    operateTree(bool) {
      this.isExpandAll = bool
      this.treeStandBy = false
      this.getStandardList()
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    async refreshTreeList(node) {
      const parameter = {}
      if (node.data.isStandard) {
        parameter.standardId = node.data.id
      } else {
        parameter.standardId = node.data.standardId
        parameter.parentId = node.data.id
      }
      const res = await StdSubjectDomainService.getTreeList(parameter)
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 选中主题树，请求关联列表
    handleNodeClick(data) {
      this.selectedTheme = data
      this.selectedThemeId = data.id
      if (this.selectedTheme.isStandard) {
        return
      }
      this.getRelationClassList()
    },
    // 获取关联实体列表
    async getRelationClassList() {
      const parameter = {
        id: this.selectedThemeId,
        keyword: this.entityKeyword,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      if (this.entityKeyword) {
        parameter.pageNo = 1
      }
      const res = await StdSubjectDomainService.getRelationClassList(parameter)
      if (res && res.data && res.code === 0) {
        this.tableData = res.data
        if (res.page) {
          this.recordCount = res.page.recordCount
        }
        this.pageNoClass = 1
      }
    },
    // 选中关联实体
    handleSelectionChange(val) {
      this.selectedEntityList = val.map((item) => {
        return item.id
      })
    },
    addTheme(data, node) {
      this.themeDialog = true
      this.dialogThemeTitle = '新增主题'
      this.selectedTheme = data
      this.selectedNode = node
      this.pageNoClass = 1
      this.themeForm = {
        seqNo: undefined,
        name: '',
        code: '',
        remark: '',
      }
    },
    handleThemeSave() {
      this.$refs.themeForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          if (this.dialogThemeTitle === '新增主题') {
            this.savetheme()
          } else {
            this.updatetheme()
          }
        }
      })
    },
    async savetheme() {
      const parameter = {
        model: this.themeForm,
      }
      // 当层级为标准时，新增只传标准id。其他层级需要加上parentId
      if (this.selectedTheme.isStandard) {
        parameter.model.standardId = this.selectedTheme.id
      } else {
        parameter.model.standardId = this.selectedTheme.standardId
        parameter.model.parentId = this.selectedTheme.id
      }
      const res = await StdSubjectDomainService.save(parameter)
      if (res && res.code === 0 && res.data) {
        this.$message.success(res.msg)
        this.closeThemeDialog()
        // 及时更改树的变化
        this.selectedNode.childNodes = []
        this.$set(this.selectedTheme, 'children', await this.refreshTreeList(this.selectedNode))
      }
      this.btnLoading = false
      if (this.listType === 2) {
        this.queryTreeList()
      }
    },
    async updatetheme() {
      const parameter = {
        model: this.themeForm,
      }
      delete parameter.model.createdTime
      const res = await StdSubjectDomainService.update(parameter)
      if (res && res.code === 0 && res.data) {
        this.$message.success(res.msg)
        this.closeThemeDialog()
        // 及时更改树的变化,以及排序
        for (const key in res.data) {
          this.$set(this.selectedTheme, key, res.data[key])
        }
        this.selectedNode.parent.childNodes = []
        this.$set(
          this.selectedNode.parent.data,
          'children',
          await this.refreshTreeList(this.selectedNode.parent)
        )
      }
      this.btnLoading = false
      if (this.listType === 2) {
        this.queryTreeList()
      } else if (this.listType === 1) {
        this.partialRefresh()
      }
    },
    // 局部刷新
    partialRefresh() {
      const node = this.selectedNode
      node.loaded = false
      node.loadData()
      node.parent.loaded = false
      node.parent.loadData()
    },
    async editTheme(data, node) {
      this.selectedTheme = data
      this.selectedNode = node
      this.themeDialog = true
      this.dialogThemeTitle = '编辑主题'
      const res = await StdSubjectDomainService.detail({ id: data.id })
      if (res && res.code === 0 && res.data) {
        this.themeForm = res.data
      }
      this.btnLoading = false
    },
    // 删除主题
    delTheme(data, node) {
      this.selectedTheme = data
      this.$confirm('是否确认删除', '删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await StdSubjectDomainService.remove({ data: [data.id] })
          if (res && res.code === 0) {
            this.$message.success(res.msg)
            this.tableData = []
            this.selectedTheme = {}
            this.selectedThemeId = ''
            if (this.listType === 2) {
              this.queryTreeList()
            } else {
              // 及时更改树的变化
              const parent = node.parent
              parent.childNodes.forEach((item, index) => {
                if (item.data.id === data.id) {
                  parent.childNodes.splice(index, 1)
                }
              })
            }
          }
        })
        .catch(() => {})
    },
    addEntity() {
      if (this.selectedTheme.isStandard) {
        this.$message.warning('请选择标准下的主题')
        return
      }
      if (!this.selectedThemeId) {
        this.$message.warning('请选择标准下的主题')
        return
      }
      this.associateDialog = true
      this.$nextTick(() => {
        this.$refs.classTable.clearSelection()
      })
      this.pageNoClass = 1
      this.getAllEntity()
      this.getClassList()
    },
    // 多选删除关联实体
    delMore() {
      if (!this.selectedEntityList.length) {
        this.$message({
          message: '请选择实体',
          type: 'warning',
        })
        return
      }
      this.$confirm('是否确认删除所选实体', '删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await StdSubjectDomainService.removeSubjectDomainRelation({
            data: this.selectedEntityList,
          })
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            if (this.tableData.length === 1 && this.pageNo > 1) {
              this.pageNo -= 1
            }
            // 删除后清空选中状态
            this.$nextTick(() => {
              this.$refs.table.clearSelection()
            })
            this.getRelationClassList()
          }
        })
        .catch(() => {})
    },
    // 删除关联实体
    delEntity(id) {
      this.$confirm('是否确认删除', '删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await StdSubjectDomainService.removeSubjectDomainRelation({
            data: [id],
          })
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            if (this.tableData.length === 1 && this.pageNo > 1) {
              this.pageNo -= 1
            }
            this.getRelationClassList()
          }
        })
        .catch(() => {})
    },
    async viewEntity(id) {
      const res = await stdClassListService.classDetail({
        id,
      })
      if (res && res.code === 0 && res.data) {
        this.entityForm = res.data
      }
      this.entityDialog = true
    },
    // 保存主题与实体关联数据
    async saveAssociate() {
      if (!this.selectedClassList.length) {
        this.$message.warning('请选择实体')
        return
      }
      // 区分新增和删除
      const addList = []
      const delList = []
      _.map(this.selectedClassList, (item) => {
        if (!item.isCheck) addList.push(item.classId)
      })
      const checkList = _.filter(this.allEntityList, (item) => {
        return item.isCheck
      })
      _.map(checkList, (item) => {
        if (!_.find(this.selectedClassList, ['classId', item.classId])) {
          delList.push(item.classId)
        }
      })
      this.btnLoading = true
      const parameter = {
        // classIds: this.selectedClassList,
        addList,
        delList,
        subjectDomainId: this.selectedThemeId,
      }
      const res = await StdSubjectDomainService.saveRelation(parameter)
      if (res && res.code === 0 && res.data) {
        this.$message.success(res.msg)
      }
      this.btnLoading = false
      this.associateDialog = false
      this.getRelationClassList()
    },
  },
}
</script>

<style lang="scss" scoped>

.leftCard {
  // height: calc(100vh - 240px);
  height: 100%;
  // border: 1px solid #dcdcdc;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  /deep/.el-card__body {
    height: calc(100vh - 165px);
    overflow: auto;
  }
}
.rightTop {
  .btnBox {
    justify-content: flex-end;
  }
}
.tableBox {
  height: calc(100% - 56px);
}
.associateDialog {
  /deep/.el-dialog__body {
    padding: 20px !important;
  }
}
.associateTable {
  height: calc(100% - 50px);
}
/deep/.el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}
.list {
  height: calc(100vh - 270px);
  .listItem {
    align-items: center;
    // height: 40px;
    .leftSpan {
      width: 50%;
    }
    .rightSpan {
      width: 50%;
      justify-content: flex-end;
    }
  }
  .active {
    background: #cceeff;
  }
  .noData {
    margin-top: 338px;
  }
}
.icon-bg-circleLeft:before,
.icon-bg-circleRight:before {
  color: var(--buttonPrimaryBg);
}
/deep/ .el-tree-node__content {
  height: 32px !important;
}
/deep/ .el-tree {
  height: calc(100% - 52px);
  overflow-y: auto;
  overflow-x: hidden;
}

</style>
